import React from "react"
import { dummyClick } from "../../utilities"
import Title from "./Title"
import Subtitle from "./Subtitle"
import Text from "./Text"
import Icon from "./Icon"

const WIDTH = 144
const WIDTH_PX = `${WIDTH}px`

const Card = ({ img, imgOverlay, children, borderStyle, onClick }) => (
  <div className={`a-card rounded-3 shadow-4 ${borderStyle}`} onClick={onClick}>
    <div className="relative">
      {imgOverlay}
      <img className="db" src={img} width={WIDTH_PX} height={WIDTH_PX} />
    </div>
    <div className="t-ph1 t-pb1" style={{ maxWidth: WIDTH_PX }}>
      {children}
    </div>
  </div>
)

Card.defaultProps = {
  onClick: dummyClick,
  borderStyle: "",
  img: "/images/sample_images/sample_jpg.jpg",
  style: {},
  imgOverlay: null
}

// withSelection HOC

const withSelection = (Card) => ({ selected, upNext, ...rest }) => {
  const borderStyle = selected ? { borderStyle: "a-card-selected" } : {}
  return (
    <div className="selected">
      {selected && <p className="t-mt0 ttu f--3">{upNext}</p>}
      <Card {...Object.assign(rest, borderStyle)} />
    </div>
  )
}

const CardWithSelection = withSelection(Card)

CardWithSelection.defaultProps = {
  upNext: "EN Up next"
}

export default Card
export { CardWithSelection, WIDTH, WIDTH_PX }
